import { gql } from '@apollo/client';

export const QUERY = gql`
  query ShowRegistrationFormFields($formId: Int!, $organizationId: Int!) {
    showRegistrationForm(formId: $formId, organizationId: $organizationId) {
      fields {
        id
        row
        column
        target
        required
        form_field_definition_id
        enabled
        label
        options
        multiselect
        internal
        type
      }
    }
  }
`;
